import { ArrowUpRight } from 'lucide-react';
import { profile } from '@/data';
import { cn } from '@/lib/cn';
import { Section } from '@/components/layout/Section';
import { Reveal } from '@/components/ui/Reveal';
import { Portrait } from '@/components/ui/Portrait';

/**
 * Each stat points at the section that evidences it.
 *
 * A number a visitor cannot trace is just decoration; making them links means
 * "10–12 services" is one click from the role where that happened. The order
 * matches profile.stats.
 */
const STAT_TARGETS = ['#experience', '#experience', '#experience', '#experience'] as const;

export function About() {
  return (
    <Section id="about" title="About">
      <div className="grid gap-10 sm:grid-cols-[auto_1fr] sm:items-start">
        <Reveal className="justify-self-center sm:justify-self-start">
          <Portrait />
        </Reveal>

        <div className="space-y-4">
          {profile.summary.map((line, i) => (
            <Reveal key={line.slice(0, 32)} index={i}>
              <p className="text-pretty text-foreground/90">{line}</p>
            </Reveal>
          ))}
        </div>
      </div>

      <dl className="mt-10 grid grid-cols-2 gap-4 lg:grid-cols-4">
        {profile.stats.map((stat, i) => (
          <Reveal key={stat.label} index={i}>
            <a
              href={STAT_TARGETS[i] ?? '#experience'}
              className={cn(
                'group flex h-full flex-col rounded-(--radius-card) border border-border bg-card p-5',
                'transition-[transform,border-color,box-shadow] duration-200',
                'hover:-translate-y-0.5 hover:border-primary/40 hover:shadow-sm',
                'motion-reduce:transition-none motion-reduce:hover:translate-y-0',
              )}
            >
              <dd className="text-2xl font-bold tracking-tight text-foreground tabular-nums">
                {stat.value}
              </dd>
              <dt className="mt-1 flex items-start gap-1 text-sm text-muted-foreground">
                {stat.label}
                <ArrowUpRight
                  aria-hidden
                  className="mt-0.5 h-3.5 w-3.5 shrink-0 opacity-0 transition-opacity group-hover:opacity-70 group-focus-visible:opacity-70"
                />
              </dt>
            </a>
          </Reveal>
        ))}
      </dl>
    </Section>
  );
}
